















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import PdfBarcodeDocument from "../../components/pdf-barcode-document.vue";
import { ApiData } from "@/lib/apiData";

@Component({
  components: {
    "pdf-barcode-document": PdfBarcodeDocument,
  },
})
export default class PrintCaseLabels extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  spinShow: boolean = false;
  @Prop({ type: Object, default: new ApiData() }) data: ApiData;
  get printData() {
    return {
      pages: this.caseLabelCodes,
      pagesTitle: this.pageTitlePopup,
      objectType: "caseLabel",
    };
  }
  get caseLabelCodes() {
    return this.data.pages;
  }

  get pageTitlePopup() {
    return this.data.pagesTitle;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  created() {}
}
